import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "inline-flex items-center"
};
import Star from "@/modules/vue/components/Star.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Talent',
  props: {
    talent: {
      default: 0
    },
    size: null
  },
  setup(__props) {
    const props = __props;
    // bronze: 20, 35
    // silver: 50, 65
    // gold: 80, 95
    // red: 100
    const offset = 5;
    const step = 15;
    const level = computed(() => Math.ceil((props.talent - offset) / step));
    const half = computed(() => props.talent <= 95 && (props.talent - offset - 1) % (step * 2) < step);
    const enhanced = computed(() => props.talent > 100);
    const color = computed(() => {
      if (!props.talent) {
        return ColorEnum.Gray;
      }
      if (enhanced.value) {
        return ColorEnum.Red;
      }
      return {
        0: ColorEnum.Bronze,
        1: ColorEnum.Bronze,
        2: ColorEnum.Bronze,
        3: ColorEnum.Silver,
        4: ColorEnum.Silver,
        5: ColorEnum.Gold,
        6: ColorEnum.Gold,
        7: ColorEnum.Red
      }[level.value];
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Star, {
        enhanced: _unref(enhanced),
        color: _unref(color),
        half: _unref(half),
        empty: !__props.talent,
        size: __props.size
      }, null, 8, ["enhanced", "color", "half", "empty", "size"])]);
    };
  }
});